import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnessaTranslationService } from '../../translation/anessa-translation.service';
import { AffectedScenarioInput } from '../../../models/results/scenario-comparison/affected-scenario-input.model';

@Component({
  selector: 'app-simulator-scenario-confirmation-popup',
  templateUrl: './simulator-scenario-confirmation-popup.component.html',
  styleUrl: './simulator-scenario-confirmation-popup.component.scss'
})
export class SimulatorScenarioConfirmationPopup {

  invalidScenariosMap?: Map<string, string[]>;
  affectedScenariosMap?: Map<string, AffectedScenarioInput[]>;

  // table properties
  inputHeader = 'input';
  originalValueHeader = 'originalValue';
  updatedValueHeader = 'updatedValue';
  headers = [this.inputHeader, this.originalValueHeader, this.updatedValueHeader];
  headerTranslations = {
    [this.inputHeader]: 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.AFFECTED_INPUTS_TABLE.INPUT_HEADER',
    [this.originalValueHeader]: 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.AFFECTED_INPUTS_TABLE.ORIGINAL_VALUE_HEADER',
    [this.updatedValueHeader]: 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.AFFECTED_INPUTS_TABLE.UPDATED_VALUE_HEADER',
  };

  keepInvalidScenariosTooltip: string;
  deleteInvalidScenariosTooltip: string;

  invalidScenariosArePresent = false;
  affectedScenariosArePresent = false;
  ackAndDeleteBtnText = '';
  ackAndKeepBtnText = '';
  isScenarioSimulation = false;

  constructor(private dialogRef: MatDialogRef<SimulatorScenarioConfirmationPopup>,
    public translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) public dataIn: {
      invalidScenariosMap: Map<string, string[]>,
      affectedScenariosMap: Map<string, AffectedScenarioInput[]>,
      isScenarioSimulation: boolean
    }) {
    this.invalidScenariosMap = this.dataIn.invalidScenariosMap;
    this.affectedScenariosMap = this.dataIn.affectedScenariosMap;
    this.invalidScenariosArePresent = this.invalidScenariosMap && this.invalidScenariosMap.size > 0;
    this.affectedScenariosArePresent = this.affectedScenariosMap && this.affectedScenariosMap.size > 0;
    this.isScenarioSimulation = this.dataIn.isScenarioSimulation;

    this.setTooltips();
    this.setBtnText();
  }

  acknowledge() {
    this.dialogRef.close(ScenarioConfirmationResponse.ACKNOWLEDGE);
  }

  acknowledgeAndKeepScenarios() {
    this.dialogRef.close(ScenarioConfirmationResponse.ACKNOWLEDGE_AND_KEEP);
  }

  acknowledgeAndDeleteScenarios() {
    this.dialogRef.close(ScenarioConfirmationResponse.ACKNOWLEDGE_AND_DELETE);
  }

  onSkipAndProceedClick() {
    this.dialogRef.close(ScenarioConfirmationResponse.SKIP_AND_PROCEED);
  }

  onCancelClick() {
    this.dialogRef.close(ScenarioConfirmationResponse.CANCEL);
  }

  getHeaderTranslationID() {
    if (!this.affectedScenariosArePresent && this.invalidScenariosArePresent) {
      return 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.HEADER.INVALID';
    } else if (this.affectedScenariosArePresent && !this.invalidScenariosArePresent) {
      return 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.HEADER.AFFECTED';
    } else {
      return 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.HEADER.INVALID_AND_AFFECTED';
    }
  }

  getInvalidScenariosDescription() {
    return this.isScenarioSimulation
      ? 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.INVALID_SCENARIOS_DESCRIPTION.POST_SIMULATION'
      : 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.INVALID_SCENARIOS_DESCRIPTION.PRE_SIMULATION';
  }

  getAffectedScenariosDescription() {
    return this.isScenarioSimulation
      ? 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.AFFECTED_SCENARIOS_DESCRIPTION.POST_SIMULATION'
      : 'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.AFFECTED_SCENARIOS_DESCRIPTION.PRE_SIMULATION';
  }

  private setTooltips() {
    if (this.invalidScenariosArePresent && !this.isScenarioSimulation) {
      // set tooltips for invalid scenarios
      this.keepInvalidScenariosTooltip = this.translationService.get(
        'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.KEEP_INVALID_SCENARIOS_TOOLTIP'
      );
      this.deleteInvalidScenariosTooltip = this.translationService.get(
        'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.DELETE_INVALID_SCENARIOS_TOOLTIP'
      );
    }
  }

  private setBtnText() {
    switch (true) {
      case this.invalidScenariosArePresent && this.affectedScenariosArePresent:
        this.ackAndKeepBtnText = this.translationService.get(
          'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.BUTTONS.ACKNOWLEDGE_AND_KEEP_SCENARIOS_BTN'
        );
        this.ackAndDeleteBtnText = this.translationService.get(
          'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.BUTTONS.ACKNOWLEDGE_AND_DELETE_BTN'
        );
        break;
      case this.invalidScenariosArePresent && !this.affectedScenariosArePresent:
        this.ackAndKeepBtnText = this.translationService.get(
          'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.BUTTONS.KEEP_BTN'
        );
        this.ackAndDeleteBtnText = this.translationService.get(
          'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.BUTTONS.DELETE_BTN'
        );
        break;
      case !this.invalidScenariosArePresent && this.affectedScenariosArePresent:
        this.ackAndKeepBtnText = this.translationService.get(
          'SCENARIO_COMPARISON.SCENARIO_CONFIRMATION_POPUP.BUTTONS.ACKNOWLEDGE_BTN'
        );
        break;
    }
  }
}

export enum ScenarioConfirmationResponse {
  ACKNOWLEDGE_AND_KEEP = 'ack-and-keep',
  ACKNOWLEDGE_AND_DELETE = 'ack-and-delete',
  ACKNOWLEDGE = 'ack',
  SKIP_AND_PROCEED = 'skip-and-proceed',
  CANCEL = 'cancel'
}
